export const splitLines = (commentsBlock, doc, width) => {
  const allLines = [];
  const inputLines = commentsBlock.split("\r");
  inputLines.forEach((line) => {
    const lines = doc.splitTextToSize(line, width);
    allLines.push(...lines);
  });
  return allLines;
};

export const hasAnyDataRow = (array, fields = []) => {
  return (
    Array.isArray(array) &&
    array.some((item) =>
      fields.some((field) => {
        const value = item[field];
        return value !== undefined && value !== null && value !== "";
      })
    )
  );
};

export const isValidImageData = (image) => {
  return typeof image === "string" && image.startsWith("data:image/");
};
